/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConsommationAgregatDto } from '../../models/consommation-agregat-dto';

export interface GetConsommations$Params {
  /**
   * dkCodeInstallation
   */
  dkCodeInstallation: string;
}

export function getConsommations(
  http: HttpClient,
  rootUrl: string,
  params: GetConsommations$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<ConsommationAgregatDto>> {
  const rb = new RequestBuilder(rootUrl, getConsommations.PATH, 'get');
  if (params) {
    rb.query('dkCodeInstallation', params.dkCodeInstallation, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConsommationAgregatDto>;
    })
  );
}

getConsommations.PATH = '/v1/reportings_p1/consommations';
